module.exports = __webpack_public_path__ + "img/elements.bda58a96.png";